export default function ({ app }) {
  if (app.$auth.passwordChangeIsRequired()) {
    return app.$auth.logout()
  }
  return Promise.resolve()
}
